import * as Comp from './Layout';

export const LModal = {
  Container: Comp.Container,
  Header: Comp.Header,
  Footer: Comp.Footer,
  Content: Comp.Content,
  Heading: Comp.Heading,
};
